module.exports = __webpack_public_path__ + "img/temp-blog-05.cc10d861.jpg";